// extracted by mini-css-extract-plugin
export default {"text":"css_text__11HTn"};